export var EluType;
(function (EluType) {
    EluType["REMOTE"] = "remote";
    EluType["SMALLTOUCH"] = "smallTouch";
})(EluType || (EluType = {}));
(function (EluType) {
    function createOptions(t) {
        return [
            {
                label: t('wheelie:form.elu.remote'),
                value: EluType.REMOTE,
            },
            {
                label: t('wheelie:form.elu.smallTouch'),
                value: EluType.SMALLTOUCH,
            },
        ];
    }
    EluType.createOptions = createOptions;
})(EluType || (EluType = {}));
export var EluStatus;
(function (EluStatus) {
    EluStatus["NEW"] = "new";
    EluStatus["INPROGRESS"] = "inProgress";
    EluStatus["SAVED"] = "saved";
    EluStatus["FINISHED"] = "finished";
    EluStatus["CANCELLED"] = "cancelled";
    EluStatus["TIMED_OUT"] = "timedOut";
    EluStatus["FAILED"] = "failed";
})(EluStatus || (EluStatus = {}));
(function (EluStatus) {
    function createEluStatusLabel(t, state) {
        switch (state) {
            case EluStatus.NEW:
                return t('wheelie:form.elu.status.new');
            case EluStatus.INPROGRESS:
            case EluStatus.SAVED:
                return t('wheelie:form.elu.status.inProgress');
            case EluStatus.FINISHED:
                return t('wheelie:form.elu.status.finished');
            case EluStatus.CANCELLED:
                return t('wheelie:form.elu.status.cancelled');
            case EluStatus.TIMED_OUT:
                return t('wheelie:form.elu.status.timedout');
            case EluStatus.FAILED:
                return t('wheelie:form.elu.status.failed');
            default:
                return 'no status';
        }
    }
    EluStatus.createEluStatusLabel = createEluStatusLabel;
    function isDone(state) {
        return [
            EluStatus.TIMED_OUT,
            EluStatus.CANCELLED,
            EluStatus.FINISHED,
            EluStatus.FAILED,
        ].includes(state);
    }
    EluStatus.isDone = isDone;
})(EluStatus || (EluStatus = {}));
